import React from "react";
import { useEffect } from "react";
import _ from "lodash";
import { useState } from "react";
import { removeTypename } from "js/utils/Helper";
import AppGraphQl from "js/graphql/resolvers/noticia.resolver";
import { GQLParamBuilder } from "../../../../../helpers";

const FEEDBACK_MSGS = {
  NOTICIA_NOT_FOUND: "Noticia no encontrada"
};

const fetchData = async (client, id, idNoticia, setFormParams) => {
  try {
    const opBuilder = new GQLParamBuilder(client);

    const { getNoticiaById } = AppGraphQl.queries;

    opBuilder.setOperation(getNoticiaById);

    const variables = {
      idPrograma: parseInt(id),
      idNoticia: parseInt(idNoticia) || idNoticia,
      order: "asc",
      orderBy: "idNoticia",
      page: 1,
      rowsPerPage: 1
    };

    opBuilder.setVariables({ ...variables });

    const result = await opBuilder.exec();

    if (!result.data && !result.data.getNoticia) {
      throw new Error(FEEDBACK_MSGS.NOTICIA_NOT_FOUND);
    }
    const noticiaData = removeTypename(result.data.getNoticia);
    return noticiaData;
  } catch (error) {
    setFormParams(prev => ({
      ...prev,
      errors: error.message
    }));

    return null;
  }
};

export const useGetNoticia = ({
  client,
  idPrograma,
  idNoticia,
  setFormParams
}) => {
  const [noticia, setNoticia] = useState();

  useEffect(
    () => {
      const getNoticia = async () => {
        if (
          !_.isNil(idPrograma) &&
          !_.isNil(idNoticia) &&
          idNoticia !== "new"
        ) {
          const noticiaFound = await fetchData(
            client,
            idPrograma,
            idNoticia,
            setFormParams
          );
          if (!_.isNil(noticiaFound)) {
            setNoticia(noticiaFound);
          }
        }
      };
      getNoticia();
    },
    [idPrograma, idNoticia]
  );

  return noticia;
};
